export const GET_PLAN_TRANSACTIONS_ABORTED = 'GET_PLAN_TRANSACTIONS_ABORTED';
export const GET_PLAN_TRANSACTIONS_REQUESTED =
  'GET_PLAN_TRANSACTIONS_REQUESTED';
export const GET_PLAN_TRANSACTIONS_COMPLETED =
  'GET_PLAN_TRANSACTIONS_COMPLETED';
export const GET_PLAN_TRANSACTIONS_FAILED = 'GET_PLAN_TRANSACTIONS_FAILED';
export const RESET_PLAN_TRANSACTIONS_REQUESTED =
  'RESET_PLAN_TRANSACTIONS_REQUESTED';
export const RESET_PLAN_TRANSACTIONS_COMPLETED =
  'RESET_PLAN_TRANSACTIONS_COMPLETED';
